import { useEffect, useRef, useState } from 'react';
import { currentMailSize as getCurrentMailSize } from '@web-common/state/getter';
import { preUploadAttachment } from '../../util';
import { actions as attachmentActions } from '@web-common/state/reducer/attachmentReducer';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { MailTabActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { isMainAccount } from '@web-mail/util';
import { apis, apiHolder, } from 'api';
import { attachmentDownloadAction } from '@web-common/state/action';
const replaceQueryString = (url, name, value) => {
    const re = new RegExp(name + '=[^&]*', 'gi');
    return url.replace(re, name + '=' + value);
};
const diskApi = apiHolder.api.requireLogicalApi(apis.netStorageImpl);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const eventApi = apiHolder.api.getEventApi();
const fileApi = apiHolder.api.getFileApi();
const systemApi = apiHolder.api.getSystemApi();
const loggerApi = apiHolder.api.requireLogicalApi(apis.loggerApiImpl);
const inElectron = systemApi.isElectron();
let changeImgArr = [];
let deleteCatchAttArr = [];
let addCatchAttArr = [];
const useReupload = () => {
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const cacheAttachment = useAppSelector(state => state.mailReducer.cacheAttachment);
    const mailEntities = useAppSelector(state => state.mailReducer.mailEntities);
    const mailEntitiesRef = useRef(mailEntities);
    mailEntitiesRef.current = mailEntities;
    const currentMailRef = useRef(currentMail);
    currentMailRef.current = currentMail;
    const optSenderMainEmail = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSenderMainEmail; });
    const dispatch = useAppDispatch();
    const originMail = useRef();
    const originInitSenderStr = useRef();
    originInitSenderStr.current = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
    const [cloudAttInfo, setCloudAttInfo] = useState();
    useEffect(() => {
        diskApi.doGetNSFolderInfo({ type: 'cloudAtt' }).then(res => {
            setCloudAttInfo(res);
        });
    }, []);
    const currentMailSize = getCurrentMailSize(currentMail, attachments);
    const currentMailSizeRef = useRef(currentMailSize);
    useEffect(() => {
        currentMailSizeRef.current = currentMailSize;
    }, [currentMailSize]);
    const clearMidFile = async (mid) => {
        if (!mid) {
            return;
        }
        try {
            dispatch(mailActions.doChangeCacheAttachment({ id: mid, operationType: 'delete' }));
            if (inElectron) {
                const dirPath = await mailApi.mkDownloadDir('regular', { mid, fid: 100001 });
                window.electronLib.fsManage.remove(dirPath);
            }
        }
        catch (error) {
            console.log('delete Change error', error);
        }
    };
    if (!currentMailId) {
        return {
            reUploadHandler: () => {
                return null;
            },
            clearMidFile,
            reUploadHandlerWeb: () => {
                return null;
            },
        };
    }
    const silentDownload = async (downloadInfo, file, newCid) => {
        const mid = newCid.toString();
        let defaultPath = '';
        const sep = window.electronLib.env.isMac ? '/' : '\\';
        const dirPath = await mailApi.mkDownloadDir('regular', { mid, fid: 100001 });
        const realName = await window.electronLib.fsManage.setDownloadFileName(dirPath, downloadInfo.fileName);
        defaultPath = `${dirPath}${sep}${realName}`;
        const saveConf = {
            noStoreData: undefined,
            recordPerf: true,
            recordFileType: file.type === 'netfolder' || file.cloudAttachment ? 'cloud' : 'common',
            flowScene: 'mail_write',
            _account: originInitSenderStr.current || '',
        };
        const fileTarget = Object.assign(Object.assign({}, downloadInfo), { filePath: defaultPath });
        let res;
        try {
            res = await fileApi.download(fileTarget, saveConf);
        }
        catch (err) {
            return Promise.reject(err);
        }
        if (res.succ) {
            dispatch(mailActions.doChangeCacheAttachment({ id: newCid, value: file, operationType: 'localPathChange', localPath: res.fileModel.filePath }));
            return res;
        }
        else {
            return Promise.reject();
        }
    };
    const readFileUpload = async (fileName, filePath, type, newCid, originFileUrl, isImg) => {
        let localfile;
        try {
            localfile = await window.electronLib.fsManage.readFile(filePath);
        }
        catch (err) {
            return Promise.reject({ type, fileName, success: false, err });
        }
        const fileObj = new File([localfile], fileName);
        if (isImg && originFileUrl) {
            try {
                await inlineImgReUpload(fileObj, newCid, originFileUrl, filePath);
                return Promise.resolve({ type, fileName, success: true });
            }
            catch (err) {
                return Promise.reject({ type, fileName, success: false, err });
            }
        }
        let preTrtAtts = preUploadAttachment({
            fileList: [fileObj],
            currentMailId: newCid,
            currentMailSize: currentMailSizeRef.current,
            cloudAttInfo,
            flag: { usingCloud: false },
        });
        if (preTrtAtts && preTrtAtts.length > 0) {
            try {
                if (type === 'originalFile' || type === 'forwardAsAttach' || type === 'diskNormalFile') {
                    addCatchAttArr.push({ type: 'localFile', value: preTrtAtts[0] });
                }
                await localAttachmentReUpload({ file: preTrtAtts[0], newCid, localPath: filePath });
                return Promise.resolve({ type, fileName, success: true });
            }
            catch (err) {
                return Promise.reject({ type, fileName, success: false, err });
            }
        }
        else {
            return Promise.reject({ type, fileName, success: false, err: '附件添加失败' });
        }
    };
    const localAttachmentReUpload = async (params) => {
        var _a, _b, _c, _d, _e;
        const { file, newCid, localPath, type, oldCid, oldAccount, newAccount } = params;
        const _file = Object.assign({}, file);
        const onFile = _file.file;
        if (!onFile) {
            return Promise.reject({ type: ((_a = _file === null || _file === void 0 ? void 0 : _file.flag) === null || _a === void 0 ? void 0 : _a.usingCloud) ? 'localCloudFile' : 'localFile', fileName: _file.fileName, success: false, err: '文件不存在' });
        }
        const accounts = await accountApi.getMainAndSubAccounts();
        const mainAccount = accounts[0].mainAccount;
        const flag = Object.assign({}, _file === null || _file === void 0 ? void 0 : _file.flag);
        if (mainAccount !== optSenderMainEmail) {
            flag._account = optSenderMainEmail;
        }
        if (type === 'localCloudFile') {
            if (oldCid && newCid) {
                const oldMailDb = await mailApi.doGetMailFromDB(oldCid, oldAccount || '');
                const newMailDb = await mailApi.doGetMailFromDB(newCid, newAccount || '');
                const oldAttDb = (_c = (((_b = oldMailDb === null || oldMailDb === void 0 ? void 0 : oldMailDb.entry) === null || _b === void 0 ? void 0 : _b.attachment) || [])) === null || _c === void 0 ? void 0 : _c.find(_ => _.realId === file.realId);
                if (oldMailDb && newMailDb && oldAttDb) {
                    oldAttDb.fileSourceKey = ((_d = oldAttDb.fileSourceKey) === null || _d === void 0 ? void 0 : _d.split(';')[0]) + ';' + newMailDb._id;
                    const oldReduxAtt = attachments.find(_ => _.mailId === oldCid && _.realId === file.realId);
                    console.log('oldReduxAtt', oldReduxAtt, oldAttDb, newMailDb);
                    if (oldReduxAtt) {
                        await mailApi.doSaveAttachmentToDB({ cid: newCid, _account: newAccount || '', attachment: [oldAttDb] });
                        dispatch(attachmentActions.cloneAttachments([Object.assign(Object.assign({}, oldReduxAtt), { mailId: newCid })]));
                        return Promise.resolve({ type: ((_e = _file === null || _file === void 0 ? void 0 : _file.flag) === null || _e === void 0 ? void 0 : _e.usingCloud) ? 'localCloudFile' : 'localFile', fileName: _file.fileName, success: true });
                    }
                }
                console.log('oldMailDb oldMailDb oldMailDb', oldMailDb);
            }
        }
        return mailApi
            .doUploadAttachment({
            cid: newCid,
            _account: flag._account || '',
            attach: localPath || onFile,
            uploader: {},
            flag,
        })
            .then(({ realId, expired }) => {
            var _a;
            _file.status = 'success';
            _file.realId = realId;
            _file.expired = expired;
            if (localPath) {
                _file.reuploadLocalPath = localPath;
            }
            dispatch(attachmentActions.doAddAttachment([_file]));
            return Promise.resolve({ type: ((_a = _file === null || _file === void 0 ? void 0 : _file.flag) === null || _a === void 0 ? void 0 : _a.usingCloud) ? 'localCloudFile' : 'localFile', fileName: _file.fileName, success: true });
        })
            .catch(err => {
            var _a;
            _file.status = 'fail';
            dispatch(attachmentActions.doAddAttachment([_file]));
            return Promise.reject({ type: ((_a = _file === null || _file === void 0 ? void 0 : _file.flag) === null || _a === void 0 ? void 0 : _a.usingCloud) ? 'localCloudFile' : 'localFile', fileName: _file.fileName, success: false, err });
        });
    };
    const inlineImgReUpload = async (file, newCid, originFileUrl, localPath) => {
        const accounts = await accountApi.getMainAndSubAccounts();
        const mainAccount = accounts[0].mainAccount;
        const flag = { inline: true };
        if (mainAccount !== optSenderMainEmail) {
            flag._account = optSenderMainEmail;
        }
        return mailApi
            .doUploadAttachment({
            cid: newCid,
            _account: flag._account || '',
            attach: localPath || file,
            uploader: undefined,
            flag,
        })
            .then(({ fileUrl }) => {
            fileUrl && changeImgArr.push({ originFileUrl, replaceFileUrl: fileUrl });
            addCatchAttArr.push({ type: 'inlineImg', value: { file, fileUrl } });
            return Promise.resolve({ type: 'inlineImg', fileName: file.name, success: true });
        })
            .catch(err => {
            changeImgArr.push({ originFileUrl, replaceFileUrl: 'error' });
            return Promise.reject({ type: 'inlineImg', fileName: file.name, success: false, err });
        });
    };
    const diskReUpload = (file, newCid, isCloud, _type) => {
        return mailApi
            .doAddAttachment(newCid, [file], { usingCloud: isCloud }, optSenderMainEmail)
            .then(() => {
            const { fileName, fileUrl, fileSize, id, expired, type } = file;
            const attr = [
                {
                    flag: { usingCloud: isCloud },
                    mailId: newCid,
                    fileUrl,
                    size: fileSize,
                    fileSize: fileSize,
                    name: fileName,
                    fileName,
                    cloudAttachment: isCloud,
                    type,
                    id,
                    expired,
                    status: 'success',
                },
            ];
            dispatch(attachmentActions.doAddAttachment(attr));
            return Promise.resolve({ type: _type ? _type : isCloud ? 'diskCloudFile' : 'diskFile', fileName: file.fileName, success: true });
        })
            .catch(err => {
            return Promise.reject({ type: _type ? _type : isCloud ? 'diskCloudFile' : 'diskFile', fileName: file.fileName, success: false, err });
        });
    };
    const diskNormalReUpload = async (file, newCid, localPath) => {
        if (!inElectron) {
            return diskReUpload(file, newCid, false);
        }
        let res;
        if (localPath) {
            res = {
                succ: true,
                fileModel: {
                    filePath: localPath,
                },
            };
        }
        else {
            try {
                let downloadInfo = {
                    fileUrl: file.fileUrl,
                    fileName: file.fileName,
                    fileSize: file.fileSize,
                    fileSourceType: 1,
                };
                res = await silentDownload(downloadInfo, file, newCid);
            }
            catch (err) {
                return Promise.reject({ type: 'diskNormalFile', fileName: file.fileName, success: false, err: '附件添加失败' });
            }
        }
        if (res.succ && res.fileModel.filePath) {
            return readFileUpload(file.fileName, res.fileModel.filePath, 'diskNormalFile', newCid);
        }
        else {
            return Promise.reject({ type: 'diskNormalFile', fileName: file.fileName, success: false, err: '附件添加失败' });
        }
    };
    const originalInlineImgReUpload = async (file, newCid, originFileUrl, localPath, latestedDraft) => {
        var _a, _b, _c, _d, _e, _f, _g;
        let res;
        if (localPath) {
            res = {
                succ: true,
                fileModel: {
                    filePath: localPath,
                },
            };
        }
        else {
            try {
                let originMailId = null;
                let parId = null;
                let fileMime = undefined;
                if (latestedDraft) {
                    const { attachment } = latestedDraft.entry;
                    originMailId = latestedDraft.id;
                    let onAttachment = ((_a = (attachment || [])) === null || _a === void 0 ? void 0 : _a.filter(_ => {
                        return !_.deleted && _.fileSize === file.fileSize && _.fileName === file.fileName;
                    })) || [];
                    parId = (_b = onAttachment[0]) === null || _b === void 0 ? void 0 : _b.id;
                    fileMime = (_c = onAttachment[0]) === null || _c === void 0 ? void 0 : _c.fileMime;
                }
                else {
                    originMailId = file.fileSourceKey.split(';')[0];
                    let onAttachment = ((_e = (_d = originMail.current) === null || _d === void 0 ? void 0 : _d.entry.attachment) === null || _e === void 0 ? void 0 : _e.filter(_ => {
                        return !_.deleted && _.fileSize === file.fileSize && _.fileName === file.fileName;
                    })) || [];
                    parId = (_f = onAttachment[0]) === null || _f === void 0 ? void 0 : _f.id;
                    fileMime = (_g = onAttachment[0]) === null || _g === void 0 ? void 0 : _g.fileMime;
                }
                if (!originMailId || !parId) {
                    return Promise.reject({ type: 'originalInlineImg', fileName: file.fileName, success: false, err: '图片添加失败' });
                }
                const downloadInfo = Object.assign(Object.assign({}, file), { cloudAttachment: file.cloudAttachment, downloadContentId: originMailId, downloadId: parId + ';' + originMailId, fileMime: fileMime, fileOriginUrl: replaceQueryString(file.fileOriginUrl, 'Part', parId), fileSourceKey: originMailId + ';' + parId, fileUrl: replaceQueryString(file.fileUrl, 'part', parId), id: parId, mailId: originMailId, realId: 0, type: 'download' });
                res = await silentDownload(downloadInfo, file, newCid);
            }
            catch (err) {
                return Promise.reject({ type: 'originalInlineImg', fileName: file.fileName, success: false, err: '图片添加失败' });
            }
        }
        if (res.succ && res.fileModel.filePath) {
            return readFileUpload(file.fileName, res.fileModel.filePath, 'originalInlineImg', newCid, originFileUrl, true);
        }
        else {
            return Promise.reject({ type: 'originalInlineImg', fileName: file.fileName, success: false, err: '图片添加失败' });
        }
    };
    const originalFileReUpload = async (file, newCid, localPath, latestedDraft) => {
        var _a, _b, _c, _d, _e, _f, _g;
        let res;
        if (localPath) {
            res = {
                succ: true,
                fileModel: {
                    filePath: localPath,
                },
            };
        }
        else {
            try {
                let originMailId = null;
                let parId = null;
                let fileMime = undefined;
                if (latestedDraft) {
                    const { attachment } = latestedDraft.entry;
                    originMailId = latestedDraft.id;
                    let onAttachment = ((_a = (attachment || [])) === null || _a === void 0 ? void 0 : _a.filter(_ => {
                        return !_.deleted && _.fileSize === file.fileSize && _.fileName === file.fileName;
                    })) || [];
                    parId = (_b = onAttachment[0]) === null || _b === void 0 ? void 0 : _b.id;
                    fileMime = (_c = onAttachment[0]) === null || _c === void 0 ? void 0 : _c.fileMime;
                }
                else {
                    originMailId = file.fileSourceKey.split(';')[0];
                    let onAttachment = ((_e = (_d = originMail.current) === null || _d === void 0 ? void 0 : _d.entry.attachment) === null || _e === void 0 ? void 0 : _e.filter(_ => {
                        return !_.deleted && _.fileSize === file.fileSize && _.fileName === file.fileName;
                    })) || [];
                    parId = (_f = onAttachment[0]) === null || _f === void 0 ? void 0 : _f.id;
                    fileMime = (_g = onAttachment[0]) === null || _g === void 0 ? void 0 : _g.fileMime;
                }
                if (!originMailId || !parId) {
                    return Promise.reject({ type: 'originalFile', fileName: file.fileName, success: false, err: '附件添加失败' });
                }
                const downloadInfo = Object.assign(Object.assign({}, file), { cloudAttachment: file.cloudAttachment, downloadContentId: originMailId, downloadId: parId + ';' + originMailId, fileMime: fileMime, fileOriginUrl: replaceQueryString(file.fileOriginUrl, 'Part', parId), fileSourceKey: originMailId + ';' + parId, fileUrl: replaceQueryString(file.fileUrl, 'part', parId), id: parId, mailId: originMailId, realId: 0, type: 'download' });
                res = await silentDownload(downloadInfo, file, newCid);
            }
            catch (err) {
                return Promise.reject({ type: 'originalFile', fileName: file.fileName, success: false, err: '附件添加失败' });
            }
        }
        if (res.succ && res.fileModel.filePath) {
            return readFileUpload(file.fileName, res.fileModel.filePath, 'originalFile', newCid);
        }
        else {
            return Promise.reject({ type: 'originalFile', fileName: file.fileName, success: false, err: '附件添加失败' });
        }
    };
    const forwardAsAttachFileReUpload = async (file, newCid, localPath) => {
        let res;
        if (localPath) {
            res = {
                succ: true,
                fileModel: {
                    filePath: localPath,
                },
            };
        }
        else {
            try {
                res = await silentDownload(file, file, newCid);
            }
            catch (err) {
                return Promise.reject({ type: 'forwardAsAttach', fileName: file.fileName, success: false, err: '附件添加失败' });
            }
        }
        if (res.succ && res.fileModel.filePath) {
            return readFileUpload(file.fileName, res.fileModel.filePath, 'forwardAsAttach', newCid);
        }
        else {
            return Promise.reject({ type: 'forwardAsAttach', fileName: file.fileName, success: false, err: '附件添加失败' });
        }
    };
    const replaceImg = () => {
        if (changeImgArr.length <= 0 || !changeImgArr) {
            return Promise.resolve(changeImgArr);
        }
        return new Promise((resolve, reject) => {
            var _a, _b;
            (_b = (_a = eventApi
                .sendSysEvent({
                eventName: 'writePageDataExchange',
                eventStrData: 'inlineImgReUpload',
                eventData: changeImgArr,
            })) === null || _a === void 0 ? void 0 : _a.then(() => {
                resolve(changeImgArr);
            })) === null || _b === void 0 ? void 0 : _b.catch(error => {
                reject(error);
            });
        });
    };
    const getReuploadBaseInfos = async (params) => {
        const { fromAccount, toAccount } = params;
        let info = {};
        try {
            const cookieInfo_form = await systemApi.doGetCookies(undefined, isMainAccount(fromAccount) ? '' : fromAccount);
            const userInfo_from = systemApi.getCurrentUser(fromAccount);
            if (!cookieInfo_form || !userInfo_from)
                throw new Error('获取cookie或者用户信息失败');
            info.fromAccount = {
                account: fromAccount,
                sid: userInfo_from === null || userInfo_from === void 0 ? void 0 : userInfo_from.sessionId,
                node: userInfo_from === null || userInfo_from === void 0 ? void 0 : userInfo_from.node,
                coremail: (cookieInfo_form === null || cookieInfo_form === void 0 ? void 0 : cookieInfo_form.Coremail) || (cookieInfo_form === null || cookieInfo_form === void 0 ? void 0 : cookieInfo_form.coremail),
                qiyeToken: cookieInfo_form.QIYE_TOKEN || cookieInfo_form.qiye_token,
            };
            const cookieInfo_to = await systemApi.doGetCookies(undefined, isMainAccount(toAccount) ? '' : toAccount);
            const userInfo_to = systemApi.getCurrentUser(toAccount);
            if (!cookieInfo_to || !userInfo_to)
                throw new Error('获取cookie或者用户信息失败');
            info.toAccount = {
                account: toAccount,
                sid: userInfo_to === null || userInfo_to === void 0 ? void 0 : userInfo_to.sessionId,
                node: userInfo_to === null || userInfo_to === void 0 ? void 0 : userInfo_to.node,
                coremail: (cookieInfo_to === null || cookieInfo_to === void 0 ? void 0 : cookieInfo_to.Coremail) || (cookieInfo_to === null || cookieInfo_to === void 0 ? void 0 : cookieInfo_to.coremail),
                qiyeToken: cookieInfo_to.QIYE_TOKEN || cookieInfo_to.qiye_token,
            };
        }
        catch (error) {
            console.log('getReuploadBaseInfos error', error);
            return Promise.reject(error);
        }
        return info;
    };
    const batchReupload = async (params) => {
        try {
            const transferRes = await mailApi.doTransferAtts(params);
            return transferRes;
        }
        catch (error) {
            return Promise.reject(error);
        }
    };
    const toProxy = (fileUrl, _account) => {
        var _a;
        const isMain = isMainAccount(_account);
        if (!isMain) {
            const _token = ((_a = mailConfApi.accountTokens.find(token => token.account === _account)) === null || _a === void 0 ? void 0 : _a.token) || '';
            const newUrl = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.replace(/(\/js6\/s)/, '/commonweb/proxy$1');
            return `${newUrl}&_token=${_token}`;
        }
        return fileUrl;
    };
    const inlineImgReplace = async (reUploadRes, oldData, newData) => {
        return new Promise((resolve, reject) => {
            var _a;
            const { attachments } = reUploadRes;
            if (!attachments || !attachments.length) {
                resolve(true);
            }
            const replaceImgArr = [];
            (attachments || []).map(item => {
                const { originId, inlined, id } = item;
                if (!!inlined) {
                    replaceImgArr.push({
                        originFileUrl: toProxy(mailApi.buildUploadedAttachmentDownloadUrl(oldData.content, originId, undefined, oldData._account ? systemApi.getSessionNameOfSubAccount(oldData._account) : '', oldData.agentNode), oldData._account),
                        replaceFileUrl: toProxy(mailApi.buildUploadedAttachmentDownloadUrl(newData.content, Number(id), undefined, newData._account ? systemApi.getSessionNameOfSubAccount(newData._account) : '', newData.agentNode), newData._account),
                    });
                }
            });
            if (!(replaceImgArr === null || replaceImgArr === void 0 ? void 0 : replaceImgArr.length)) {
                resolve(true);
            }
            console.log('imagereplace 图片替换数组', replaceImgArr);
            (_a = eventApi
                .sendSysEvent({
                eventName: 'writePageDataExchange',
                eventStrData: 'inlineImgReUpload',
                eventData: replaceImgArr,
            })) === null || _a === void 0 ? void 0 : _a.then(res => {
                console.log('imagereplace sendSysEvent res', res);
                setTimeout(() => {
                    resolve(true);
                }, 1500);
            }).catch(error => {
                reject(error);
            });
        });
    };
    const reUploadHandlerWeb = async (resendAccount, noAtt, forceSave) => {
        var _a;
        const catchAttArr = cacheAttachment[currentMailId] ? ((_a = cacheAttachment[currentMailId]) === null || _a === void 0 ? void 0 : _a.attachment) || [] : [];
        originInitSenderStr.current = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
        const latestedCont = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry.content.content) || '';
        const oldAccount = originInitSenderStr.current;
        let reUploadInfo = null;
        const oldCid = currentMailId;
        let fromComposeId = null;
        try {
            const data = await mailApi.doGetContentFromDB(oldCid, oldAccount || '');
            fromComposeId = data._id;
        }
        catch (error) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            loggerApi.track('web_reupload_fail', { reason: '重传ComposeId获取失败', oldCid });
            return Promise.reject('重传ComposeId获取失败');
        }
        if (!fromComposeId) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            loggerApi.track('web_reupload_fail', { reason: '重传ComposeId获取失败', oldCid });
            return Promise.reject('重传ComposeId获取失败');
        }
        try {
            reUploadInfo = await getReuploadBaseInfos({ fromAccount: oldAccount, toAccount: resendAccount || '' });
        }
        catch (error) {
            console.log('getReuploadBaseInfos error', error);
            loggerApi.track('web_reupload_fail', { reason: 'getReuploadBaseInfos error' });
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            return Promise.reject(error);
        }
        if (!reUploadInfo) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            loggerApi.track('web_reupload_fail', { reason: '重传参数获取失败' });
            return Promise.reject('重传参数获取失败');
        }
        reUploadInfo.fromComposeId = fromComposeId;
        let newContent = null;
        let regerateCid = '';
        try {
            newContent = await mailApi.doReSendInitMail(currentMailId, resendAccount, true, latestedCont);
            reUploadInfo.toComposeId = newContent === null || newContent === void 0 ? void 0 : newContent._id;
            regerateCid = (newContent === null || newContent === void 0 ? void 0 : newContent.cid) || '';
        }
        catch (error) {
            console.log('doReSendInitMail error', error);
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            return Promise.reject('重生失败');
        }
        if (noAtt) {
            dispatch(mailActions.doReplaceCid({ cid: oldCid, newCid: regerateCid, _account: resendAccount, mailEditStatus: '' }));
            dispatch(MailTabActions.doReplaceTabId({ oldId: String(oldCid), newId: String(regerateCid) }));
            return true;
        }
        let excludeAttachment = [];
        try {
            excludeAttachment = await mailApi.doGetExcludeAttIds(oldCid, latestedCont);
            console.log('excludeAttachment', excludeAttachment);
            reUploadInfo.excludeAttachment = excludeAttachment || [];
        }
        catch (error) {
            return Promise.reject('error');
        }
        let reUploadRes = null;
        try {
            reUploadRes = await batchReupload(reUploadInfo);
            console.log('batchReupload reUploadRes', reUploadRes);
        }
        catch (error) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            return Promise.reject('重传附件失败');
        }
        if (!reUploadRes) {
            Promise.reject('重传附件失败');
        }
        try {
            console.log('imagereplace 开始替换图片 当前邮件内容', latestedCont);
            await inlineImgReplace(reUploadRes, {
                content: { _account: reUploadInfo === null || reUploadInfo === void 0 ? void 0 : reUploadInfo.fromAccount.account, _id: reUploadInfo.fromComposeId },
                _account: reUploadInfo === null || reUploadInfo === void 0 ? void 0 : reUploadInfo.fromAccount.account,
                agentNode: reUploadInfo.fromAccount.node,
            }, {
                content: { _account: reUploadInfo === null || reUploadInfo === void 0 ? void 0 : reUploadInfo.toAccount.account, _id: reUploadInfo.toComposeId },
                _account: reUploadInfo === null || reUploadInfo === void 0 ? void 0 : reUploadInfo.toAccount.account,
                agentNode: reUploadInfo.toAccount.node,
            });
        }
        catch (error) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            return Promise.reject('替换内联图片失败');
        }
        let latestedDraftId = (reUploadRes === null || reUploadRes === void 0 ? void 0 : reUploadRes.draftId) || '';
        if (!latestedDraftId) {
            try {
                if (forceSave) {
                    newContent.entry.content.content = forceSave();
                }
                console.log('imagereplace 编辑器最新内容', newContent.entry.content.content, forceSave);
                latestedDraftId = await mailApi.doGetLatestedDraftId({ content: newContent, oldCid });
            }
            catch (error) {
                dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
                return Promise.reject('获取草稿id失败');
            }
        }
        console.log('imagereplace newContent', newContent);
        let newCid = '';
        try {
            const draftParams = {
                id: latestedDraftId,
                mailType: 'draft',
                writeType: 'editDraft',
                withoutPlaceholder: true,
                _account: newContent._account,
            };
            const res = await mailApi.initModel(draftParams);
            if (res) {
                newCid = res.cid;
                res.recoverCid = oldCid;
                dispatch(mailActions.doReplaceCid({ cid: oldCid, newCid: newCid, _account: resendAccount, con: res.entry.content.content, mailEditStatus: 'reUploading' }));
                dispatch(MailTabActions.doReplaceTabId({ oldId: String(oldCid), newId: String(newCid) }));
                regerateCid && dispatch(attachmentActions.doDelAttachment({ cid: [oldCid] }));
                const filterAttachment = (res.entry.attachment || []).filter(item => !item.inlined);
                filterAttachment.forEach(attachment => {
                    const temp = Object.assign(Object.assign({}, attachment), { mailId: res.cid, downloadContentId: res.entry.id, downloadId: attachment.fileUrl + res.entry.id, type: 'download', cloudAttachment: attachment.type === 'netfolder' });
                    dispatch(attachmentDownloadAction(temp, {
                        forward: true,
                        entryId: res.entry.id,
                        cid: res.cid || '0',
                    }));
                });
            }
        }
        catch (error) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
            return Promise.reject('重新编辑草稿失败');
        }
        dispatch(mailActions.doModifyMailEditStatus({ cid: newCid, status: '' }));
        return true;
    };
    const reUploadHandler = async (resendAccount) => {
        var _a, _b, _c, _d;
        const catchAttArr = cacheAttachment[currentMailId] ? ((_a = cacheAttachment[currentMailId]) === null || _a === void 0 ? void 0 : _a.attachment) || [] : [];
        try {
            const currentAttachments = attachments.filter(item => item && item.mailId === currentMailId);
            loggerApi.track('useReupload_start', { orginalAtta: currentAttachments, catchAtta: catchAttArr });
        }
        catch (error) {
            console.log('loggerApi_useReupload_start', error);
        }
        const oldCid = currentMailId;
        const oldAccount = currentMail._account;
        originInitSenderStr.current = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '';
        const newContent = await mailApi.doReSendInitMail(currentMailId, resendAccount);
        const newCid = newContent.cid || '';
        dispatch(mailActions.doReplaceCid({ cid: oldCid, newCid, _account: resendAccount, mailEditStatus: 'reUploading' }));
        try {
            dispatch(MailTabActions.doReplaceTabId({ oldId: String(oldCid), newId: String(newCid) }));
            changeImgArr = [];
            deleteCatchAttArr = [];
            addCatchAttArr = [];
            dispatch(attachmentActions.doClearAttachmentById(oldCid));
            const originalFile = catchAttArr.find(_ => _.type === 'originalInlineImg' || _.type === 'originalFile');
            if (originalFile) {
                const originMailId = originalFile.value.fileSourceKey.split(';')[0];
                if (mailEntitiesRef.current[originMailId]) {
                    originMail.current = mailEntitiesRef.current[originMailId];
                }
                else {
                    const origin = await mailApi.doGetMailContent(originMailId, false, true, undefined, { _account: currentMail._account });
                    originMail.current = origin;
                }
            }
            const parallelRequest = [];
            const serialRequest = [];
            let latestedDraft = null;
            if ((currentMail === null || currentMail === void 0 ? void 0 : currentMail.mailFrom) === 'subordinate' && (catchAttArr || []).find(_ => _.type === 'originalInlineImg' || _.type === 'originalFile')) {
                try {
                    const res = await mailApi.doSaveTemp({ content: currentMail, saveDraft: true, auto: true, callPurpose: 'resetSaveDraft' });
                    const { draftId } = res;
                    if (!draftId) {
                        dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
                        return Promise.reject('获取草稿id失败');
                    }
                    const draftDetail = await mailApi.doGetMailContent(draftId, false, true, undefined, { _account: originInitSenderStr.current });
                    latestedDraft = draftDetail;
                    console.log('latestedDraft', latestedDraft, draftId);
                    if (!latestedDraft) {
                        dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
                        return Promise.reject('获取草稿详情失败');
                    }
                }
                catch (error) {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: oldCid, status: '' }));
                    return Promise.reject('获取草稿失败');
                }
            }
            for (let i = 0; i < catchAttArr.length; i++) {
                let file = catchAttArr[i];
                let newFileValue = Object.assign(Object.assign({}, file.value), { mailId: newCid });
                if ((file === null || file === void 0 ? void 0 : file.type) === 'inlineImg' && (file === null || file === void 0 ? void 0 : file.value)) {
                    if (((_b = file.value) === null || _b === void 0 ? void 0 : _b.name) && ((_c = file.value) === null || _c === void 0 ? void 0 : _c.size) && ((_d = file.value) === null || _d === void 0 ? void 0 : _d.type)) {
                        newFileValue = file.value;
                        try {
                            newFileValue.mailId = newCid;
                        }
                        catch (error) {
                            console.log('setMailId error', error);
                        }
                    }
                }
                if (file.type === 'localFile') {
                    parallelRequest.push(localAttachmentReUpload({ file: newFileValue, newCid, localPath: file.localPath }));
                }
                else if (file.type === 'localCloudFile') {
                    parallelRequest.push(localAttachmentReUpload({ file: newFileValue, newCid, localPath: file.localPath, type: file.type, oldCid, oldAccount, newAccount: resendAccount }));
                }
                else if (file.type === 'inlineImg') {
                    parallelRequest.push(inlineImgReUpload(newFileValue, newCid, file.originFileUrl, file.localPath));
                }
                else if (file.type === 'diskFile') {
                    serialRequest.push(() => diskReUpload(newFileValue, newCid, false));
                }
                else if (file.type === 'pasteAtt') {
                    serialRequest.push(() => diskReUpload(newFileValue, newCid, false));
                }
                else if (file.type === 'diskCloudFile') {
                    serialRequest.push(() => diskReUpload(newFileValue, newCid, true));
                }
                else if (file.type === 'pasteCloud') {
                    serialRequest.push(() => diskReUpload(newFileValue, newCid, true));
                }
                else if (file.type === 'diskNormalFile') {
                    if (!inElectron)
                        continue;
                    serialRequest.push(() => diskNormalReUpload(newFileValue, newCid, file.localPath));
                    deleteCatchAttArr.push({ type: file.type, value: newFileValue });
                }
                else if (file.type === 'originalInlineImg') {
                    if (!inElectron)
                        continue;
                    serialRequest.push(() => originalInlineImgReUpload(newFileValue, newCid, file.originFileUrl, file.localPath, latestedDraft));
                }
                else if (file.type === 'originalCloudFile') {
                    const fileData = {
                        id: newFileValue.cloudIdentity,
                        expired: newFileValue.expired,
                        fileName: newFileValue.fileName,
                        fileSize: newFileValue.fileSize,
                        type: newFileValue.type,
                        fileUrl: newFileValue.fileUrl,
                        isCloud: true,
                        downloadContentId: newFileValue.fileUrl,
                        downloadId: newFileValue.fileUrl,
                    };
                    serialRequest.push(() => diskReUpload(fileData, newCid, true, file.type));
                    deleteCatchAttArr.push({ type: file.type, value: newFileValue });
                    addCatchAttArr.push({ type: 'diskCloudFile', value: fileData });
                }
                else if (file.type === 'originalFile') {
                    if (!inElectron)
                        continue;
                    serialRequest.push(() => originalFileReUpload(newFileValue, newCid, file.localPath, latestedDraft));
                    deleteCatchAttArr.push({ type: file.type, value: newFileValue });
                }
                else if (file.type === 'forwardAsAttach') {
                    if (!inElectron)
                        continue;
                    serialRequest.push(() => forwardAsAttachFileReUpload(newFileValue, newCid, file.localPath));
                    deleteCatchAttArr.push({ type: file.type, value: newFileValue });
                }
            }
            const serialPromise = () => new Promise(async (resolve) => {
                const allRes = [];
                for (let i = 0; i < serialRequest.length; i++) {
                    let _res;
                    try {
                        _res = await serialRequest[i]();
                        allRes.push(_res);
                    }
                    catch (err) {
                        allRes.push(err);
                    }
                }
                return resolve(allRes);
            });
            return Promise.allSettled(parallelRequest)
                .then(async (res) => {
                const _res = [...res];
                try {
                    const serialRes = await serialPromise();
                    serialRes.forEach(resItem => {
                        if (resItem.success) {
                            _res.push({ status: 'fulfilled', value: resItem });
                        }
                        else {
                            _res.push({ status: 'rejected', reason: resItem });
                        }
                    });
                }
                catch (err) {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: newCid, status: '' }));
                }
                try {
                    await replaceImg();
                }
                catch (err) {
                    dispatch(mailActions.doModifyMailEditStatus({ cid: newCid, status: '' }));
                    _res.forEach(_ => {
                        const value = _.status === 'rejected' ? _.reason : _.value;
                        if (['inlineImg', 'originalInlineImg'].includes(value.type)) {
                            value.success = false;
                            value.err = '替换编辑器图片链接失败';
                        }
                    });
                }
                deleteCatchAttArr.forEach(_ => {
                    dispatch(mailActions.doChangeCacheAttachment({ id: oldCid, value: _.value, operationType: 'delete' }));
                });
                addCatchAttArr.forEach(_ => {
                    if (_.type === 'localFile') {
                        dispatch(mailActions.doChangeCacheAttachment({ id: oldCid, type: _.type, value: _.value, operationType: 'add' }));
                    }
                    else if (_.type === 'diskCloudFile') {
                        dispatch(mailActions.doChangeCacheAttachment({ id: oldCid, type: _.type, value: _.value, operationType: 'add' }));
                    }
                    else if (_.type === 'inlineImg') {
                        dispatch(mailActions.doChangeCacheAttachment({ id: oldCid, type: _.type, value: _.value.file, operationType: 'add', originFileUrl: _.value.fileUrl }));
                    }
                });
                dispatch(mailActions.doReplaceCacheAttachment({ oldCid, newCid }));
                dispatch(mailActions.doModifyMailEditStatus({ cid: newCid, status: '' }));
                try {
                    loggerApi.track('useReupload_complete', { completeRes: _res });
                }
                catch (error) {
                    console.log('loggerApi_useReupload_complete', error);
                }
                setTimeout(() => {
                    eventApi.sendSysEvent({
                        eventName: 'toSaveDraft',
                        eventStrData: '',
                        eventData: {
                            type: 'localAndRemote',
                            trigger: 'attachChange',
                            mailId: newCid,
                        },
                    });
                }, 400);
                return _res;
            })
                .catch(err => {
                dispatch(mailActions.doModifyMailEditStatus({ cid: newCid, status: '' }));
                return null;
            });
        }
        catch (e) {
            dispatch(mailActions.doModifyMailEditStatus({ cid: newCid, status: '' }));
            return null;
        }
    };
    return { reUploadHandler, clearMidFile, reUploadHandlerWeb };
};
export default useReupload;
